import React, { Component, createRef } from "react"
import Modal from "./modal"
import * as endpoints from "../../api/endpoints"
import ReCaptcha from "react-google-recaptcha"

export default class MerchantContactUsModalContent extends Component {
  constructor(props) {
    super(props)
    this.recaptchaRef = createRef()
    this.state = {
      modalOpen: true,
      subject: props.title && props.text ? `${props.title} - ${props.text}` : "",
      feedback: "",
      fullName: "",
      email: "",
      status: "",
      validEmail: true,
      validSubject: true,
      validName: true,
      validFeedback: true,
      language: (document.body && document.body.dataset.language) || "da",
      ipAddress: props.ipAddress,
      recaptchaResponse: null,
      validReCaptcha: true,
    }
  }

  componentDidMount() {
    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.execute()
    }
  }

  componentWillUnmount() {
    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.reset()
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault()

    if (!this.state.email || !this.state.subject || !this.state.feedback || !this.state.fullName || !this.state.recaptchaResponse) {
      if (!this.state.email) {
        this.setState({ validEmail: false })
      }
      if (!this.state.subject) {
        this.setState({ validSubject: false })
      }
      if (!this.state.feedback) {
        this.setState({ validFeedback: false })
      }
      if (!this.state.fullName) {
        this.setState({ validName: false })
      }
      if (!this.state.recaptchaResponse) {
        this.setState({ validReCaptcha: false })
      }
    } else {
      const { recaptchaResponse, ipAddress } = this.state
      const res = await endpoints.verifyReCaptcha({ response: recaptchaResponse, remoteip: ipAddress })
      const verified = res.data
      if (!verified) {
        return
      }
      try {
        await endpoints.merchantContact(
          this.props.merchantId,
          this.state.subject,
          this.state.feedback,
          this.state.fullName,
          this.state.email,
          this.state.language,
        )
        this.setState({
          status: this.props.successMessage ?? "<p>Thank you, we have recieved your message. You will hear from us within 48 hours.</p>",
        })
      } catch (error) {
        this.setState({ status: this.props.errorMessage ?? "<p>Ooops, something happened :) Please try again later.</p>" })
      }
    }
  }

  handleRecaptcha = (response) => {
    this.setState({ recaptchaResponse: response, validReCaptcha: true })
  }

  handleChange = (event) => {
    const { target } = event
    this.setState({ [target.name]: target.value })
    this.setState({ validEmail: true, validFeedback: true, validName: true, validSubject: true })
  }

  handleReVerify = () => {
    this.setState({ verificationFailed: false })
  }

  render() {
    return (
      <Modal
        isOpen={this.state.modalOpen}
        noScrollToTop="true"
        modifier="modal--wide modal--fixed"
        overlayModifier="ReactModal__Overlay--fixed merchant-contact-us"
        bodyModifier="ReactModal__Body--open ReactModal--no-overflow"
      >
        <div className="main-body contact-us-main-body">
          <div className="page-title py-4 text-center">
            <h2 className="contact-us-title h2-tablet-large m-0 pb-2">{this.props.shopName}</h2>
            {!this.state.status ? <div className="contact-us-subtitle" dangerouslySetInnerHTML={{ __html: this.props.message }}></div> : ""}
          </div>
          {!this.state.status ? (
            <form className="contact-us form" name="contact-us">
              <div className="row contact-us-name mx-0">
                <div className="col-sm-12 px-0">
                  <div className="form-group required form__field form__field--text form__field--text--no-label is-bound is-required">
                    <input
                      type="text"
                      name="subject"
                      onChange={(e) => this.handleChange(e)}
                      defaultValue={this.state.subject}
                      className="form-control required form__item"
                      placeholder={this.props.subjectLabel || "Emne"}
                    />
                    <span className={`${this.state.validSubject ? "d-none" : ""} form__notice form__notice--box is-invalid`}>
                      {this.props.subjectErrorMessage || "Indtast et emne"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row mx-0 contact-us-comment">
                <div className="col px-0">
                  <div className="form-group requiredform__field form__field--textarea form__field--textarea--no-label is-bound is-required ">
                    <textarea
                      className="form-control required py-1 form__item"
                      name="feedback"
                      onChange={(e) => this.handleChange(e)}
                      rows="4"
                      maxLength="250"
                      placeholder={this.props.feedbackLabel || "Besked"}
                    ></textarea>
                    <span className={`${this.state.validFeedback ? "d-none" : ""} form__notice form__notice--box is-invalid`}>
                      {this.props.feedbackErrorMessage || "Indtast en besked"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="contact-details-title mt-1">
                <p className="font-medium mb-1">{this.props.yourDetailsLabel || "Dine detaljer"}</p>
              </div>
              <div className="row contact-us-name mx-0">
                <div className="col-sm-12 px-0">
                  <div className="form-group required form__field form__field--text form__field--text--no-label is-bound is-required ">
                    <input
                      type="text"
                      name="fullName"
                      onChange={(e) => this.handleChange(e)}
                      className="form-control required form__item"
                      placeholder={this.props.nameLabel || "Navn"}
                    />
                    <span className={`${this.state.validName ? "d-none" : ""} form__notice form__notice--box is-invalid`}>
                      {this.props.nameErrorMessage || "Indtast dit navn"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row mx-0 contact-us-email">
                <div className="col px-0">
                  <div className="form-group required form__field form__field--text form__field--text--no-label is-bound is-required ">
                    <input
                      type="email"
                      name="email"
                      onChange={(e) => this.handleChange(e)}
                      pattern="^(([^<>()\[\]\\.,;:\s@\x22]+(\.[^<>()\[\]\\.,;:\s@\x22]+)*)|(\x22.+\x22))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|([^<>()\[\]\\.,\x2D;:\s@\x22]([a-zA-Z\x2D0-9]+\.)+[a-zA-Z]{2,}))$"
                      className="form-control required required form__item"
                      placeholder={this.props.emailLabel || "Email"}
                    />
                    <span className={`${this.state.validEmail ? "d-none" : ""} form__notice form__notice--box is-invalid`}>
                      {this.props.emailErrorMessage || "Indtast din email"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row contact-us-submit mx-0 pt-1">
                <div className="form__field form__field--checkbox is-bound is-required">
                  <ReCaptcha ref={this.recaptchaRef} sitekey={this.props.reCaptchaSiteKey} onChange={this.handleRecaptcha} hl={this.state.language} />
                </div>
                <span className={`${this.state.validReCaptcha ? "d-none" : ""} form__notice form__notice--box is-invalid`}>
                  {this.props.reCaptchaErrorMessage || "Verificer"}
                </span>
              </div>
              <br />
              <div className="row contact-us-submit mx-0 pt-1">
                <div className="col-12 px-0 text-center">
                  <div className="form-group pb-5">
                    <button className="button button--small button--general casc-blue-dark" onClick={(e) => this.handleSubmit(e)}>
                      <span>{this.props.sumbitButtonText || "Send"}</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          ) : (
            <span dangerouslySetInnerHTML={{ __html: this.state.status }}></span>
          )}
        </div>
      </Modal>
    )
  }
}
